import { render, staticRenderFns } from "./myCombinations.vue?vue&type=template&id=1775b5c4&scoped=true"
import script from "./myCombinations.vue?vue&type=script&lang=js"
export * from "./myCombinations.vue?vue&type=script&lang=js"
import style0 from "./myCombinations.vue?vue&type=style&index=0&id=1775b5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1775b5c4",
  null
  
)

export default component.exports